<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M18 0h-6v2h6v6h2V0zM2 18v-6H0v8h8v-2z"/><!-- Created by Stepan Voevodin from the Noun Project --></svg>
